$(document).ready( function() {
    initSlideshow();

    document.addEventListener('shopify:section:load', function (event){
        initSlideshow();
        initInstagram();
    });

    $(window).on('load', function () {
        initInstagram();
        resetSearchPosition();
        if ($(window).width() > 1440) {
            resetGridCol(4);
        }
    });

    $(window).on('resize', function () {
        resetSearchPosition();
        if ($(window).width() > 1440) {
            resetGridCol(4);
        } else {
            resetGridCol(3);
        }
    });

    function resetGridCol(col) {
        $(`.view-modes [data-view="${col}"]`).trigger('click');
    }

    var announcementBar = new Swiper(document.querySelector('.announcement-bar'),{
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        pauseOnMouseEnter: true,
        delay: 3000,
      },
    });

    var recommendations = document.querySelectorAll('[data-product-recommendations]');
    recommendations.forEach(function(recommendation) {
        var column_options = JSON.parse(recommendation.dataset.productRecommendations);
        var swiper = recommendation.querySelector('.swiper');
        var swiperObj = new Swiper(swiper, {
            slidesPerView: parseInt(column_options.desktop_column),
            navigation: {
              nextEl: swiper.querySelector('.swiper-button-next'),
              prevEl: swiper.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: parseInt(column_options.mobile_column),
                },
                576: {
                    slidesPerView: parseInt(column_options.ipad_column),
                },
                768: {
                    slidesPerView: parseInt(column_options.mini_desktop_column),
                },
                1200: {
                    slidesPerView: parseInt(column_options.desktop_column),
                }
            }
        });
    });

    $(document).on('click', '.currency-selector .currency-dropdown li', function() {
        $('.currency-selector input[name="currency"]').val($(this).attr('data-value'));
        $('form.currency-selector').submit();
    });

    $('#announcement-bar-currency .currency-header').on('click', function(e) {
        e.preventDefault();
        $(this).next().toggle();
    });

    $('#nav-currency .currency-header').on('click', function(e) {
        e.preventDefault();
        $(this).next().toggle();
    });

    $(document).on('click', '.search-trigger', function() {
        $(this).next().addClass('active');
    });
  
    $(document).on('click', '.search-modal__close-button', function() {
        $(this).parents().closest('.search-popup').removeClass('active');
    });

    $(document).on('click', '.view-modes .mode', function() {
        var cols = $(this).attr('data-view');
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        $('#main-collection-product-grid').attr('data-cols', cols);
    });

    $(document).on('click', '.quick-add__input', function(e) {
        $(this).parents().closest('.collection__quick-add-form').submit();
    });

    // toggle navigation
    $('.navbar-toggler').on('click', function(){
        $('.navbar, body').toggleClass('nav-open');
        const cart_drawer = document.querySelector('cart-drawer') || false;
        if (cart_drawer) {
            cart_drawer.close();
        }
    });
    $('.navbar').on('click', function(event){
        event.stopPropagation();
    });
    $(document).on('click', function(e) {
        if (!$(event.target).hasClass('navbar-toggler')) {
            $('.navbar, body').removeClass('nav-open'); 
        }
    });

    $('.country-del').hide();
    $('#country-uk').show();
    $('.international-delivery-selector').on('change', function() {
        $('.country-del').hide();
        $("#country-"+this.value).show();
    });

    $('.parent .down-arrow').on('click', function(e){
        e.preventDefault();
        if ($(window).width() < 992) {
            $(this).parent().next().slideToggle();
        }
    });

    if ($('.nav-tabs').length) {
        $('.nav-tabs .nav-item').on('click', function(e){
            e.preventDefault();
            var target = $(this).find('a').attr('href');
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            $('.tab-content ' + target).siblings().hide();
            $('.tab-content ' + target).show();
        });
    }

    if ($('.main-swiper').length) {
        var mainSwiper = new Swiper(document.querySelector('.main-swiper'), {
            slidesPerView: 1,
            thumbs: {
                swiper: {
                    el: '.thumb-swiper',
                    slidesPerView: 'auto',
                    direction: 'vertical',
                    spaceBetween: 10,
                    slideThumbActiveClass: "swiper-slide-thumb-active",
                    breakpoints: {
                        0: {
                            direction: 'horizontal',
                            slidesPerView: '4',
                        },
                        576: {
                            direction: 'horizontal',
                            slidesPerView: '6',
                        },
                        992: {
                            direction: 'vertical',
                        }
                    },
                    on: {
                        click: function() {
                            /* Product thumbs automatic next / previous on click slide */
                            if( this.activeIndex >= this.clickedIndex ) {
                                this.slidePrev();
                            } else {
                                this.slideNext();
                            }
                        },
                        init: function() {
                            if ($(window).width() > 991) {
                                $('.thumb-swiper').height($('.main-swiper').outerHeight());
                            } else {
                                $('.thumb-swiper').height('auto');
                            }
                        },
                        resize: function() {
                            if ($(window).width() > 991) {
                                $('.thumb-swiper').height($('.main-swiper').outerHeight());
                            } else {
                                $('.thumb-swiper').height('auto');
                            }
                        }
                    }
                }
            }
        })
    }

    $('.color-label').on('click', function(){
        var label = $(this).attr('data-value');
        $('.selected-color').text(label);
    });

    if($('[data-wholesale-base-price]').length) {
       var basePrice = $('[data-wholesale-base-price]').attr('data-base-price');
       if (basePrice >= 0) {
           var convertedPrice = Utils.formatMoney(basePrice * Shopify.currency.rate);
           $('[data-wholesale-base-price]').html(convertedPrice);
       } else {
            $('[data-wholesale-base-price]').html('');
       }
    }

    $(document).on('click', '.accordion-item .accordion-title', function() {
        var _this = $(this);
        if (_this.hasClass('active')) {
            _this.removeClass('active');
            _this.next().stop(true).slideUp();
        } else {
            $('.accordion-title').removeClass('active');
            $('.accordion-content').stop(true).slideUp(function() {
                _this.addClass('active');
                _this.next().stop(true).slideDown();
            });
        }
    });

    if (window.autoSelectFirstVariant === true) {
        $('.variant-item label').first().trigger('click')
    }
    window.onload = function() {
        if (!$('.variant-item label').length) {
            $('product-form').remove();
        }
    };

    /*$('[data-swiper]').each(function() {
        var swiperItem = $('[data-swiper]')[0];
        vat swiperObj = new Swiper(swiperItem, {
            slidesPerView: 4
        });
    });*/

    $(".product-tab .tab-content-item").each(function() {
        var _self = $(this);
        _self.find(".accordion-title").click(function() {
            _self.toggleClass("active");
            _self.find(".accordion-content").toggle();
        })
    });

    $(document).on('click', '[data-boost-pfs-filter-refine-by-wrapper] .refine-by-item', function(e) {
        e.preventDefault();
        $('#boost-pfs-filter-tree .boost-pfs-filter-refine-by-items .refine-by-item:eq('+$(this).index()+') button').trigger('click');
    });
    
    // $(".product-tab .accordion-title").toggle(function(){
    //   $(".product-tab .accordion-content").toggle();      
    // });

    var oldValue = localStorage.getItem('UB_CUSTOMER_TYPE') || false;
    var newValue = window.theme.wholesaleCustomer ? 'wholesale' : 'retail';
    localStorage.setItem('UB_CUSTOMER_TYPE', newValue);
    if (oldValue != newValue) {
        fetch(`${window.Shopify.routes.root}cart.js`)
        .then(res => res.json())
        .then(function(res) {
            if (res.items.length) {
                var updates = {};
                if (window.theme.wholesaleCustomer) {
                    res.items.map(function(item) {
                        if (item.variant_title.indexOf('Pack') === -1) {
                            updates[item.key] = 0;
                        }
                    });
                } else {
                    res.items.map(function(item) {
                        if (item.variant_title.indexOf('Pack') !== -1) {
                            updates[item.key] = 0;
                        }
                    });
                }

                if (Object.keys(updates).length) {
                    const body = JSON.stringify({updates});
                    fetch(`${window.Shopify.routes.root}cart/update.js`, {...fetchConfig(), ...{ body }})
                    .then(res => res.json())
                    .then(function(res){
                        window.location.reload();
                    });
                }
            }
        });
    }
});

window.SlideshowObjs = window.SlideshowObjs || [];
function initSlideshow(section) {
  section = (typeof section === typeof undefined || section == 'undefined') ? document : section;
  var swiperItems = section.querySelectorAll('.swiper');
  swiperItems.forEach(function(swiperItem, index) {
      var _this = $(swiperItem),
          sliderOptions = _this.attr('data-slider-options');

      if (typeof(sliderOptions) !== 'undefined' && sliderOptions !== null ) {
          sliderOptions = $.parseJSON(sliderOptions);          
          swiperItem.sliderOptions = sliderOptions;
          var swiperObj = new Swiper(swiperItem, sliderOptions);
      }
  });
}

/**
 * Instagram feed
 */
function initInstagram(section) {
    section = (typeof section === typeof undefined || section == 'undefined') ? document : section;
    $(section.querySelectorAll('[data-instagram-feed]')).each(function() {
        var _this = $(this);
        var instagramFeedWrapper = $(this).attr('id');
        var tokenScriptId = '#instagram-token-' + $(this).attr('data-section-id');
        var removeSection = $(this).attr('data-element-remove');
        var count = parseInt($(this).attr('data-count')) > 0 ? parseInt($(this).attr('data-count')) : 6;
        var IGToken = JSON.parse($(tokenScriptId)[0].textContent);
        if (IGToken != '' && count > 0) {
            $(this).html('');
            $.ajax({
                url: 'https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username',
                dataType: 'jsonp',
                type: 'GET',
                data: {access_token: IGToken, limit: count},
                success: function(response){
                    if (typeof response.data != typeof undefined && response.data != 'undefined' && response.data.length) {
                        var instagramItems = response.data;
                        instagramItems.forEach(function(item) {
                            var image = null;
                            switch (item.media_type) {
                                case "IMAGE":
                                    image = item.media_url;
                                break;

                                case "VIDEO":
                                    image = item.thumbnail_url;
                                break;

                                case "CAROUSEL_ALBUM":
                                    image = item.media_url;
                                break;
                            }
                            $('#'+instagramFeedWrapper).append('<div class="swiper-slide"><a href="'+item.permalink+'" target="_blank" class="position-relative d-block"><img title="'+item.caption+'" src="'+image+'" /></a></div>');
                        });
                        setTimeout(function(){
                            var instaSwiper = new Swiper(document.getElementById('instagram-feed-swiper'), {
                                slidesPerView: count,
                                spaceBetween: 40,
                                breakpoints: {0:{slidesPerView:1.5},576:{slidesPerView:2.5},992:{slidesPerView:3},1200:{slidesPerView:4}}
                            });
                        }, 100);
                    } else {
                        console.error(response.error.message);
                        $(removeSection).remove();
                    }
                },
                error: function(response){
                    $(removeSection).remove();
                }
            });
        }
    });
}

function resetSearchPosition() {
    /*if ($(window).width() < 992) {
        $('predictive-search').appendTo($('.nav-search'));
    } else {
        $('predictive-search').appendTo($('.search-popup'));
    }*/
}